import { render } from "./ModerationExternal.vue?vue&type=template&id=5a23e8d8&scoped=true"
import script from "./ModerationExternal.vue?vue&type=script&lang=js"
export * from "./ModerationExternal.vue?vue&type=script&lang=js"

import "./ModerationExternal.vue?vue&type=style&index=0&id=5a23e8d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a23e8d8"]])

export default __exports__